import React, { useState, useContext, useEffect } from "react";
import LottieAnimation from "../components/common/Animation/LottieAnimation";
import verifyLottie from "../assets/img/animated-icons/verify.json";
import { Button, Col, Form, Input, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import AppContext from "../context/Context";
import SikkaError from "../components/common/SikkaError";
import { toast } from "react-toastify";
import Loader from "../components/common/Loader";
import { useHistory } from "react-router-dom";
import axios from "axios";
import AuthCardLayout from "../components/auth/AuthCardLayout";
import authenticationService from "../services/authenticationService";
import { ip } from "../services/apiCall";
import { detect } from "detect-browser";
import apiURL from "../services/apiURL";

const Verify = () => {
  const [loading, setLoading] = useState(false);
  // const [verifiedBoolean, setVerifiedBoolean] = useState(false);
  const { loginUserDetails,setLoginUserDetails } = useContext(AppContext);
  const [isPostSuccess, setIsPostSuccess] = useState(false);
  const [loginUserDetailsData, setLoginUserDetailsData] = useState(false);
  const [loginUserDetailsUpdated, setLoginUserDetailsUpdated] = useState(false);
   const [isVerifyBtnClicked, setIsVerifyBtnClicked] = useState(false);

  const { register, handleSubmit, errors } = useForm();
  const browser = detect();
  const API_URL = apiURL();
  let history = useHistory();

  const postVisitLogs = () => {
    let loginEmail = `login using ${loginUserDetails?.user_name}`;
    const body = {
      dev_id: `${loginUserDetails?.dev_id}`,
      email_id: `${loginUserDetails?.user_name}`,
      dev_name: `${loginUserDetails?.dev_name}`,
      is_admin: loginUserDetails?.is_partner === "0" ? "yes" : "no",
      app_id: "",
      page_name: "Login",
      action_name: "Login",
      project_name: "API Portal v4.0",
      ip_address: ip ? ip : "",
      browser_name: `${browser?.name.charAt(0).toUpperCase() + browser?.name.slice(1)}`,
      browser_version: `${browser?.version}`,
      extra_comment: "insert | " + JSON.stringify({ login: loginEmail }),
      host_name: `${window.location.hostname}`,
    };

    axios
      .post(API_URL + "visit", body, { withCredentials: true })
      .then(() => {
        setIsPostSuccess(true);})
      .catch(() => {
        // localStorage.removeItem("actn");
        // localStorage.removeItem("lngst");
        // localStorage.removeItem("tempData");
        // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
      });
  };

  const handleVerifyingCode = (values) => {
    let body = {
      user_name: loginUserDetails.user_name,
      ver_code: values.verificationCode,
    };

    setIsVerifyBtnClicked(true);
    authenticationService
      .verify(body)
      .then(() => {
        setLoading(false);
        // setVerifiedBoolean(true);
        if (loginUserDetails.dev_status.toLowerCase() !== "active") {
          toast.success(
            "Your email id verified successfully. Please contact Sikka API support to get verified by Admin after that you can login."
          );
          history.push("/v4/portal/authentication/login");
        }
        else{
          //Update in flow : 
         //once verifed we will call whoisme update loginuserdetails
          authenticationService
          .whoisme()
          .then((res) => {
            setLoginUserDetailsUpdated(true)
            setLoginUserDetailsData(res.items)
            postVisitLogs();
          })
          .catch((error) => {
            localStorage.setItem("isLoggedIn", false);
            if (error?.response?.status === 401) {
              window.location.assign(
                `${process.env.PUBLIC_URL}/authentication/login`
              );
            }            
          });
        }
     
        
      })
      .catch((error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        setLoading(false);
        toast.error(resMessage);
      }).finally(()=>{
        setIsVerifyBtnClicked(false);
      });
  };

  useEffect(() => {
    if (isPostSuccess && loginUserDetailsUpdated) {
      setLoginUserDetails(loginUserDetailsData)
      if(loginUserDetailsData.is_partner =='1'){
        if((loginUserDetails.nda_status?.toLowerCase() === "signed" ||
         loginUserDetails.nda_status?.toLowerCase() === "") || loginUserDetails.user_type.toLowerCase() !="super admin" ){
          history.push(`${process.env.PUBLIC_URL}/user/applications`);
        }
        else{
          
          history.push(`${process.env.PUBLIC_URL}/user/sign-nda`);
        }

      }
      else{
        history.push(`${process.env.PUBLIC_URL}/admin/dashboard`);
      }
    }
  }, [isPostSuccess,loginUserDetailsUpdated]);
  return (
    <>
      <AuthCardLayout>
        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={handleSubmit(handleVerifyingCode)}>
            <Row className="d-flex flex-column justify-content-center align-items-center mt-3">
              <LottieAnimation lotti={verifyLottie} height={300} width={300} />
              <h6 className="col-10 font-sans-serif d-flex justify-content-center mt-4 mb-4">
                Please verify your email id by entering verification code, Verification code sent to you on your
                registered email address.
              </h6>
              <Col sm={10}>
                <Input
                  id="verificationCode"
                  name="verificationCode"
                  placeholder="Enter verification code"
                  size="sm"
                  innerRef={register({
                    required: "Please enter a valid Verification code",
                  })}
                />
                <SikkaError error={errors["verificationCode"]?.message} className="mt-1" />
              </Col>
              <Row className="mt-3">
                <Col className="pr-0" xs="auto">
                  <Button className="ml-auto" type="submit" size="sm" color="success" disabled={isVerifyBtnClicked}>
                    Verify
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button
                    className="ml-auto"
                    size="sm"
                    color="danger"
                    onClick={() => {
                      history.push("/v4/portal/authentication/login");
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Row>
          </Form>
        )}
      </AuthCardLayout>
    </>
  );
};

export default Verify;
